import { create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { APIFileUploadResponse } from '../../stores/types';

import FileUploadService from '.';

const S3_UPLOAD_URL = Config['S3_UPLOAD_URL'];

class FileUploadAPIService implements FileUploadService {
  api: Record<string, any>;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any, baseURL: string = S3_UPLOAD_URL) {
    this.api = create({
      baseURL
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  getFileUploadConfig() {
    return this.networkCallWithAPISauce(
      this.api,
      'credentials/v1/',
      {},
      apiMethods.get
    ) as Promise<APIFileUploadResponse>;
  }
}

export default FileUploadAPIService;
